<ng-container *ngIf="isMobileView; else mobileTmpl">
  <div class="grid grid-cols-3">
    <div
      class="ib-table-cell-content__mobile-header text-left font-semibold capitalize col-span-1"
    >
      {{ column.field }}
    </div>
    <div class="col-span-2 ib-table-cell-content__mobile-value">
      <ng-container [ngTemplateOutlet]="cellTmpl"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #mobileTmpl>
  <ng-container [ngTemplateOutlet]="cellTmpl"></ng-container>
</ng-template>

<ng-template #cellTmpl>
  <ib-data-view
    [dataType]="column.dataType"
    [val]="row[column.field]"
  ></ib-data-view>
</ng-template>
